import React, { useEffect, useState } from 'react';
import { listInstruments } from './../../actions/zerodhaActions';
import { useDispatch, useSelector } from 'react-redux';
import { getForms } from '../../actions/formActions';
import SearchBoxWithListing from '../../components/Common/SearchBoxWithListing';
import _ from "lodash"

const ZerodhaInstruments = (props) => {
    const searchBoxKey = "ZERODHA_instruments_search_form";
    const listFormKey = "ZERODHA_instruments_list_form";
    const dispatch = useDispatch();
    const zerodhaState = useSelector((state) => state.zerodha);
    const formState = useSelector((state) => state.forms);
    const { formJson = {} } = formState;
    const listingJson = formJson[listFormKey] || {};
    const searchBoxJson = formJson[searchBoxKey] || {};
    const { instruments = {} } = zerodhaState;
    const [fetchingList, setFetchingList] = useState(_.isEmpty(instruments));
    const { headers = [], data: listData = [], meta = {} } = instruments;

    useEffect(() => {
        if (!_.isEmpty(instruments) && fetchingList) {
            setFetchingList(false);
        }
    }, [instruments])

    useEffect(() => {
        dispatch(getForms(listFormKey, searchBoxKey));
    }, []);

    const listApi = (payload) => {
        setFetchingList(true);
        return dispatch(listInstruments(payload, listFormKey));
    }

    return (
        <div style={{ position: 'relative', paddingBottom: '0px' }}> {/* Added padding-bottom */}
            <SearchBoxWithListing
                searchBoxKey={searchBoxKey}
                listFormKey={listFormKey}
                fetchForm={getForms}
                listApi={listApi}
                searchBoxJson={searchBoxJson}
                listingData={instruments}
            // actionsHandling={actionsHandling}
            />
        </div>

    )
}

export default ZerodhaInstruments;
